import {ActionReducerMapBuilder} from '@reduxjs/toolkit';

import {TAisSliceState} from '../ais-slice-types';
import {loadAisNotificationScenariosServices, loadAisNotificationScenariosSettingsTable} from './ais-notification-scenarios-settings-thunks';

export const createAisNotificationScenariosSettingsExtraReducer = (builder: ActionReducerMapBuilder<TAisSliceState>) => {
    builder.addCase(loadAisNotificationScenariosSettingsTable.fulfilled, (state, {payload}) => {
        state.aisNotificationScenariosSettings.notificationScenariosTable = payload.dataTable;
        state.aisNotificationScenariosSettings.recordsTotal = payload.recordsTotal;
    });
    builder.addCase(loadAisNotificationScenariosServices.fulfilled, (state, {payload}) => {
        state.aisNotificationScenariosSettings.notificationScenariosServices = payload;
    });
};
